import { IInitAction } from './init'
import { IOption } from './common'

export enum types {
  GET_LANGUAGES__STARTED = 'GET_LANGUAGES__STARTED',
  GET_LANGUAGES__SUCCESS = 'GET_LANGUAGES__SUCCESS',
  GET_LANGUAGES__FAILURE = 'GET_LANGUAGES__FAILURE',
  GET_LANGUAGES__CANCEL = 'GET_LANGUAGES__CANCEL',
}

export interface ILanguages {
  isLoading?: boolean
  list: IOption[]
}

// Action types
export interface IGetLanguagesStartedAction {
  type: types.GET_LANGUAGES__STARTED
}

export interface IGetLanguagesSuccessAction {
  type: types.GET_LANGUAGES__SUCCESS
  list: IOption[]
}

export interface IFailureAction {
  type: types.GET_LANGUAGES__FAILURE
  message: string
}

export interface IGetLanguagesCancelAction {
  type: types.GET_LANGUAGES__CANCEL
}
export type LanguagesActionsType =
  | IGetLanguagesStartedAction
  | IGetLanguagesSuccessAction
  | IFailureAction
  | IGetLanguagesCancelAction
  | IInitAction
